import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Logo Component - Body Look Care Official Logo
 * 
 * Uses the optimized logo asset from /images/logo-blc-260.webp
 * 
 * Usage:
 * - <Logo /> - Default logo
 * - <Logo variant="light" /> - White version for dark backgrounds
 * - <Logo size="sm" /> - Small size
 * - <Logo size="lg" /> - Large size
 */

const Logo = ({ 
  variant = 'default', // 'default' | 'light'
  size = 'md', // 'sm' | 'md' | 'lg' | 'xl'
  className = '',
  // Legacy props for backwards compatibility
  width,
  height,
  ...props 
}) => {
  // Size configurations
  const sizes = {
    sm: { width: 100, height: 50 },
    md: { width: 140, height: 70 },
    lg: { width: 180, height: 90 },
    xl: { width: 220, height: 110 },
  };

  // Map legacy width to size if provided
  let computedSize = size;
  if (width && !size) {
    if (width <= 100) computedSize = 'sm';
    else if (width <= 140) computedSize = 'md';
    else if (width <= 180) computedSize = 'lg';
    else computedSize = 'xl';
  }

  const currentSize = sizes[computedSize] || sizes.md;
  
  // Use explicit width/height if provided, otherwise use size config
  const finalWidth = width || currentSize.width;
  const finalHeight = height || currentSize.height;

  // For light variant on dark backgrounds, use CSS filter to invert colors
  const filterStyle = variant === 'light' 
    ? { filter: 'brightness(0) invert(1)' } 
    : {};

  return (
    <img
      src="/images/logo-blc-260.webp"
      alt="Body Look Care"
      width={finalWidth}
      height={finalHeight}
      className={cn(
        'object-contain',
        className
      )}
      style={{
        maxWidth: '100%',
        height: 'auto',
        ...filterStyle
      }}
      {...props}
    />
  );
};

export default Logo;
